module.exports = __webpack_public_path__ + "img/13.3d4f3cb2.jpg";